export class AtlasCluster {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AtlasCluster.attributeTypeMap;
    }
    constructor() {
    }
}
